import { EnhancedDropDownRHF, EnhancedDropDownRHFWithLabel, RHookFormTextField, RHookFormTextFieldWithLabel } from '@websential/cosmic-v20'
import { Grid, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ShowWithAlphabetItems, nameItems, paidByItems, rowsPerPageItems } from './offCyclePayrollConstants';

import { Link } from 'react-router-dom';
import { RHookFormDatePickerWithRange } from '../../RHookFormDatePickerWithRange';
import { formatAmountCommaSeperator } from '../../../common/Common';

interface IOffCyclePayrollSetupHeaderPanel {
    payFrequencyDDLItems: { label: string, value: string }[];
    onFrequencyChangeHandler: (selected: any) => void
    offCyclePayrollPeriodsDDL: { label: string, value: string }[];
    // onOffCyclePayrollPeriodsDDLChangeHandler: (selected: any) => void
    departmentsDDLItems: any;
    offCyclePayrollTableData: any;
    selectedpayPeriodIndex: number | null;
    // payPeriodStarDate: string | null;
    payPeriodEndDate: string | null;
    showAddRemoveEmployees: boolean;
    onClickAddEmployeesHandler: (params: any) => void;
    taxYear: number;
    onPayPeriodDateSelectionChangeHandler: (date: any) => void;
    selectedPayPeriodId: string | null;
    labelsDDLItems: any;
    selectedLabel: any;
    onLabelSelectionChangeHandler: (date: any) => void;
    onLabelChangeHandler: (e: any) => void;
    onPaymentTypeChangeHandler: (selected: any) => void
    calculatedOffCyclePayrollTableData: any;
    summary: any;
    onClickImportPayrollDataHandler: any;
    general_settings: any;
}
export const OffCyclePayrollSetupHeaderPanel: React.FC<IOffCyclePayrollSetupHeaderPanel> = ({ payFrequencyDDLItems, onFrequencyChangeHandler,
    offCyclePayrollPeriodsDDL,
    //  onOffCyclePayrollPeriodsDDLChangeHandler, 
    departmentsDDLItems, offCyclePayrollTableData,
    // payPeriodStarDate,
    payPeriodEndDate, selectedpayPeriodIndex,
    showAddRemoveEmployees,
    onClickAddEmployeesHandler,
    taxYear,
    selectedPayPeriodId,
    onPayPeriodDateSelectionChangeHandler,
    labelsDDLItems,
    onLabelSelectionChangeHandler,
    onLabelChangeHandler,
    onPaymentTypeChangeHandler,
    selectedLabel,
    calculatedOffCyclePayrollTableData,
    summary,
    onClickImportPayrollDataHandler,
      general_settings,
}) => {
    const theme = useTheme();


    // const lastProcessPayPeriod: any = offCyclePayrollPeriodsDDLfixed?.filter((item: any) => item.process === true).at(-1) ?? null;


    // const firstDateOfTaxYear = new Date(taxYear, 0, 1);  // Jan 1
    // const lastDateOfTaxYear = new Date(taxYear, 11, 31); // Dec 31

    // let startDate: Date | null = firstDateOfTaxYear;

    // if (lastProcessPayPeriod) {
    //     const lastEndDate = new Date(lastProcessPayPeriod.endDate);
    //     lastEndDate.setDate(lastEndDate.getDate() + 1); // mutate a local copy, not the original
    //     startDate = lastEndDate;
    // }
    // if (lastProcessPayPeriod) {
    //     const lastEndDate = new Date(lastProcessPayPeriod.endDate);

    //     // Check if lastEndDate is the last day of the tax year
    //     const isLastDayOfYear =
    //         lastEndDate.getFullYear() === taxYear &&
    //         lastEndDate.getMonth() === 11 &&  // December
    //         lastEndDate.getDate() === 31;

    //     if (isLastDayOfYear) {
    //         startDate = null; // calendar will be disabled
    //     } else {
    //         lastEndDate.setDate(lastEndDate.getDate() + 1);
    //         startDate = lastEndDate;
    //     }
    // }

    const [startDate, setStartDate] = useState<Date | null>(new Date(taxYear, 0, 1));
    const [viewDate, setViewDate] = useState<Date>(new Date(taxYear, 0, 1));

    const firstDateOfTaxYear = new Date(taxYear, 0, 1);  // Jan 1
    const lastDateOfTaxYear = new Date(taxYear, 11, 31); // Dec 31

    useEffect(() => {
        const lastProcessPayPeriod: any = offCyclePayrollPeriodsDDL?.filter((item: any) => item.process === true).at(-1) ?? null;

        if (lastProcessPayPeriod) {
            const lastEndDate = new Date(lastProcessPayPeriod.endDate);

            const isLastDayOfYear =
                lastEndDate.getFullYear() === taxYear &&
                lastEndDate.getMonth() === 11 &&
                lastEndDate.getDate() === 31;

            if (isLastDayOfYear) {
                setStartDate(null);
                setViewDate(firstDateOfTaxYear);
            } else {
                lastEndDate.setDate(lastEndDate.getDate() + 1);
                setStartDate(lastEndDate);
                setViewDate(lastEndDate);
            }
        } else {
            // No processed period — reset to first day of tax year
            setStartDate(firstDateOfTaxYear);
            setViewDate(firstDateOfTaxYear);
        }
    }, [offCyclePayrollPeriodsDDL, taxYear]);

    return (
        <>
            <Grid
                container
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderBottom: 0,
                    borderRadius: "2px 2px 0 0",
                    padding: "31px 20px 1rem 20px"
                }}
                columnSpacing={2}
            >
                <Grid
                    size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
                    sx={{
                        mt: "12px", "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" },
                        "& .MuiTextField-root": { marginBottom: "20px!important" }
                    }}
                >
                    <EnhancedDropDownRHF
                        selectName="paymentType"
                        testId={`payment-type-list`}
                        items={[
                            { label: "Bonus", value: 100 },
                            { label: "Off-Cycle Regular period", value: 200 },
                            { label: "Termination Pay", value: 300 },
                            { label: "Vacation Pay", value: 400 },
                        ]}
                        selectedItem={200}
                        onSelectionChangeHandler={onPaymentTypeChangeHandler}
                    />
                    <EnhancedDropDownRHF
                        selectName="payFrequencyDDLItems"
                        testId={`payFrequencyDDLItems-list`}
                        items={payFrequencyDDLItems ?? []}
                        onSelectionChangeHandler={onFrequencyChangeHandler}
                    />
                    {/* <EnhancedDropDownRHF
                            selectName="offCyclePayrollPeriodsDDL"
                            testId={`offCyclePayrollPeriodsDDL`}
                            items={offCyclePayrollPeriodsDDL ?? []}
                            onSelectionChangeHandler={onOffCyclePayrollPeriodsDDLChangeHandler}
                        /> */}
                    {/* <ProcessPayrollDropDownRHF
                        selectName="offCyclePayrollPeriodsDDL"
                        testId={`offCyclePayrollPeriodsDDL`}
                        items={offCyclePayrollPeriodsDDL ?? []}
                        onSelectionChangeHandler={onOffCyclePayrollPeriodsDDLChangeHandler}
                    />
                    {selectedpayPeriodIndex !== null && <span style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}>Pay Period#{selectedpayPeriodIndex + 1}</span>} <br />
                    {payPeriodEndDate && (<span style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}>{formatDateToShow(payPeriodStarDate)} to {formatDateToShow(payPeriodEndDate)}</span>)} */}
                    {selectedPayPeriodId && <RHookFormDatePickerWithRange
                        name={'payPeriodEndDate'}
                        label={''}
                        showlabel={false}
                        testId={"payPeriodEndDate"}
                        // disabled={!startDate}
                        viewDate={viewDate}
                        minDate={startDate ? startDate : firstDateOfTaxYear}
                        maxDate={lastDateOfTaxYear}
                        onDateSelectionChangeHandler={onPayPeriodDateSelectionChangeHandler}
                        disabled={!startDate || calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.length}
                    />}
                    {selectedLabel && !selectedLabel.process && showAddRemoveEmployees ? (
                        <Typography sx={{ fontSize: ".875rem", marginBottom: "40px", }}>
                            <Link
                                to="#"
                                className="no-underline"
                                style={{ color: theme.palette.primary.light, fontSize: ".875rem" }}
                                onClick={onClickAddEmployeesHandler}
                            >
                                Add / Remove Employees
                            </Link>
                        </Typography>
                    ) : !selectedLabel && showAddRemoveEmployees ? (
                        <Typography sx={{ fontSize: ".875rem", marginBottom: "40px", }}>
                            <Link
                                to="#"
                                className="no-underline"
                                style={{ color: theme.palette.primary.light, fontSize: ".875rem" }}
                                onClick={onClickAddEmployeesHandler}
                            >
                                Add / Remove Employees
                            </Link>
                        </Typography>
                    ) : <></>}
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
                <Grid
                    size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
                    sx={{
                        mt: "12px",
                        "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" },
                        "& .MuiTextField-root": { marginBottom: "20px!important" },
                        "& .dropDownWrapper": { marginBottom: "30px!important" }
                    }}
                >
                    {selectedPayPeriodId &&
                        <EnhancedDropDownRHF
                            // label='Label'
                            selectName="labelDDL"
                            testId={`label-ddl`}
                            items={labelsDDLItems ?? []}
                            onSelectionChangeHandler={onLabelSelectionChangeHandler}
                            isDisabled={calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.length}
                            selectedItem={'create-new'}
                        />}
                    {selectedPayPeriodId &&
                        <RHookFormTextField
                            id={'label'}
                            testId={"label"}
                            // label='Label'
                            // onChangeHandler={onLabelChangeHandler}
                            readOnly={calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.length}
                        />}
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
                {summary && <><Grid
                    size={{ xs: 12, sm: 3, md: 1, lg: 1, xl: 1 }}
                    sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
                >
                    Employees {summary && summary.totalEmployees}
                    <br /> Paid {summary && summary.paidEmployees}
                    <br />
                    Inactive {summary && summary.inactiveEmployees}
                </Grid>
                    <Grid
                        size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
                        sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
                    >
                        Paid By Cheque {summary && summary.paidByCheque}
                        <br /> Paid By Direct Deposit {summary && summary.paidByDirectDeposit}
                        <br />
                        Cheque Amount ${formatAmountCommaSeperator(summary && summary.chequeAmount)}
                        <br />
                        Direct Deposit Amount ${formatAmountCommaSeperator(summary && summary.directDepositAmount)}
                    </Grid>
                    <Grid
                        size={{ xs: 12, sm: 3, md: 1.5, lg: 1.5, xl: 1.5 }}
                        sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
                    >
                        <span style={{ height: "10px", width: "10px", background: "#E5FFE8" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Earning</span>
                        <br />
                        <span style={{ height: "10px", width: "10px", background: "#FFF2F2" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Deduction</span>
                        <br />
                        <span style={{ height: "10px", width: "10px", background: "#F6E5FF" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Reimbursement</span>

                    </Grid></>}
                <Grid
                    size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
                    sx={{
                        textAlign: "right",
                        color: "rgba(0, 0, 0, 0.6)",
                        fontSize: "0.875rem",
                        marginLeft: "auto"
                    }}
                >
                    <Link
                        to={`/reports/payroll`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Payroll Report
                    </Link>
                    <br />
                    <Link
                        to={`/reports/timesheet`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Time Sheet Report
                    </Link>
                    <br />
                    <Link
                        to={`#`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                        onClick={onClickImportPayrollDataHandler}
                    >
                        Import Payroll Data
                    </Link>
                    <br />
                    Statutory Holiday Eligibility <br />
                    <Link
                        to={`/settings/general/setup`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Time format
                    </Link> {general_settings && general_settings.timeFormat === 100 ? "1.50" : "1.30"} = 1 hr 30 mins.
                </Grid>
            </Grid>
            {offCyclePayrollTableData && offCyclePayrollTableData.items && offCyclePayrollTableData.items.length > 0 && <Grid
                container
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderBottom: 0,
                    borderRadius: "2px 2px 0 0",
                    padding: "31px 5px 0 5px",
                    "& .dropDownWrapper": { marginBottom: "0!important" },
                    "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" }
                }}
                columnSpacing={2}
            >
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>

                    <EnhancedDropDownRHF
                        selectName="name"
                        testId={`name`}
                        items={nameItems}
                        selectedItem={100}
                    // onSelectionChangeHandler={onNameChangeHandler}
                    />
                </Grid>
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>
                    <EnhancedDropDownRHF
                        selectName="ShowWithAlphabet"
                        testId={`ShowWithAlphabet`}
                        items={ShowWithAlphabetItems}
                        selectedItem={"all"}
                    // onSelectionChangeHandler={onShowWithAlphabetDDLChangeHandler}
                    /></Grid>
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>
                    <EnhancedDropDownRHF
                        selectName="paidBy"
                        testId={`PaidBy`}
                        items={paidByItems}
                        // onSelectionChangeHandler={onPaidByDDLChangeHandler}
                        selectedItem={"all"}
                    /></Grid>
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>
                    <EnhancedDropDownRHF
                        selectName="departments"
                        testId={`departments`}
                        selectedItem={"all"}
                        // onSelectionChangeHandler={onDepartmentsDDLChangeHandler}
                        items={departmentsDDLItems ?? []}
                    /></Grid>
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>
                    <EnhancedDropDownRHF
                        selectName="rowsPerPageItems"
                        testId={`rowsPerPageItems`}
                        items={rowsPerPageItems}
                        selectedItem={100}
                    // onSelectionChangeHandler={onRowsPerPageItemsDDLChangeHandler}
                    /></Grid>
            </Grid>}

        </>
    )
}

